
export const featuredPortfolio =[
    {
        id:1,
        title: "NFT Synetic",
        desc:"Client design & build for an NFT startup NFT",
        img:
        "/assets/img2.png",
        web:"https://vm799.github.io/synetic-ss/" 
    },
    {
        id:2,
        title: "Fitness services",
        desc:"Website for new gym and fitness services",
        img:
        "/assets/img3.png",
        
    },
    {
        id:3,
        title: "Educational tutoring",
        desc:"Website build for Optometry tutoring",
        img:
        "/assets/Optom_desktop.png",
        web:"https://vm799.github.io/TheOptomTutors/"
    },
]

export const webPortfolio =[
    {
        id:1,
        title: "FLY UX",
        img:
"/assets/UXDesign.png",
web: "https://www.uxfol.io/p/vaishalimehmi/03e4e086", 
    },
    {
        id:2,
        title: "DODI",
        img:
        "/assets/DODI_website.png",
        web:"https://www.dodi.org.uk"
    },
    {
        id:3,
        title: "Ludimos",
        img:
        "/assets/ludimos_desktop.png",
        web:"https://www.figma.com/proto/NaBJJbSp4VfgMACccQ5TMa/LUDIMOS-Task-1-3?node-id=336%3A179&scaling=min-zoom&page-id=336%3A0&starting-point-node-id=336%3A48"
    },
        
    

]

export const mobilePortfolio =[
    {
        id:1,
        title: "DODI Donate",
        img:
        "/assets/DODI_mobile.png",
        web:"https://www.figma.com/proto/yJ3rutwtCSb8jgwvgxuHON/DODI?node-id=43%3A338&scaling=scale-down&page-id=43%3A305&starting-point-node-id=43%3A306"
    },
    {
        id:2,
        title: "Optom Tutors",
        img:
        "/assets/img1.png",
        web:"https://vm799.github.io/TheOptomTutors/"
    },
    {
        id:3,
        title: "Home Chef",
        img:
        "/assets/figma_design.png",
        web:"https://www.figma.com/file/8P2Txqh3w0OXrEXl0JqBbd/sCRIMBA-Reds---Adventure-1?node-id=401%3A3"
    },
]

export const designPortfolio =[
    // {
    //     id:1,
    //     title: "FLY UX: Low fidelity protoype ",
    //     img:
    //     "VM-portfolio/assets/Chef.png"
    // },
    {
        id:2,
        title: "Wordle App",
        img:
        "/assets/wordle_clone.png",
        web:"https://vm799.github.io/Wordle-with-dictionary/",
    },
    // {
    //     id:3,
    //     title: "Social Media App",
    //     img:
    //     "VM-portfolio/assets/img4.png",
    // },
]

